import state from './moduleVesselNoonReportListState.js'
import mutations from './moduleVesselNoonReportListMutations.js'
import actions from './moduleVesselNoonReportListActions.js'
import getters from './moduleVesselNoonReportListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
